import { Checkbox } from "@/components/ui/checkbox";
import { ModelPicker } from "@/components/media/ModelPicker";

const POLICIES = {
  keep: ["Mantieni le foto stock", "Le foto caricate dal cliente originale vengono comunque sostituite con foto stock."],
  stock: ["Nuove foto stock pertinenti", "Foto gratuite scelte per il nuovo cliente (libreria verificata o Unsplash/Pexels)."],
  ai: ["Genera le immagini con AI", "Solo dopo la tua conferma del costo nell'anteprima."],
};
const BY_MODE = { simple: ["keep", "stock"], same_sector: ["stock", "keep", "ai"], new_sector: ["stock", "ai"] };

export default function ImageOptions({ mode, images, setImages, models }) {
  const set = (patch) => setImages({ ...images, ...patch });
  return (
    <div data-testid="dup-image-options">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Immagini</p>
      <div className="mt-3 grid gap-2 sm:grid-cols-3" role="radiogroup">
        {BY_MODE[mode].map((k) => (
          <button key={k} type="button" role="radio" aria-checked={images.policy === k} onClick={() => set({ policy: k })} data-testid={`dup-images-${k}`}
            className={`rounded-lg border p-3 text-left transition-colors ${images.policy === k ? "border-sky-500 bg-sky-50/60 ring-1 ring-sky-500" : "border-slate-200 hover:border-slate-300"}`}>
            <span className="block text-sm font-medium text-slate-900">{POLICIES[k][0]}</span>
            <span className="mt-1 block text-[11px] text-slate-500">{POLICIES[k][1]}</span>
          </button>
        ))}
      </div>
      {images.policy === "ai" && <div className="mt-3"><ModelPicker models={models} value={images.model} onChange={(m) => set({ model: m })} /></div>}
      {mode !== "new_sector" && images.policy !== "ai" && (
        <label className="mt-3 flex items-start gap-2 text-sm text-slate-700" data-testid="dup-keep-client-images">
          <Checkbox checked={images.keep_client_images} onCheckedChange={(v) => set({ keep_client_images: !!v })} className="mt-0.5" data-testid="dup-keep-client-images-checkbox" />
          <span>Copia anche le foto caricate dal cliente originale <span className="text-slate-500">(solo se sei autorizzato a riutilizzarle)</span></span>
        </label>
      )}
      <p className="mt-2 text-[11px] text-slate-500">Il logo del cliente originale non viene mai copiato: lo sostituisce un logo testuale provvisorio con il nuovo nome.</p>
    </div>
  );
}
